import React from 'react';

const VenomLogo = ({ size = 20 }: { size?: number }) => {
	return (
		<svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clip-path="url(#clip0_2_2)">
				<path
					d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
					fill="url(#paint0_linear_2_2)"
				/>
				<mask
					id="mask0_2_2"
					style={{ maskType: 'alpha' }}
					maskUnits="userSpaceOnUse"
					x="0"
					y="0"
					width="32"
					height="32"
				>
					<path
						d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
						fill="url(#paint1_linear_2_2)"
					/>
				</mask>
				<g mask="url(#mask0_2_2)">
					<g filter="url(#filter0_f_2_2)">
						<path
							d="M7.84001 5.762C15.94 4.378 24.661 9.532 27.321 17.272C29.981 25.013 25.571 32.41 17.472 33.794C9.37301 35.177 0.652006 30.024 -2.00799 22.283C-4.66799 14.542 -0.257994 7.145 7.84001 5.762Z"
							fill="url(#paint2_linear_2_2)"
						/>
					</g>
					<g filter="url(#filter1_f_2_2)">
						<path
							d="M27.178 22.05C20.856 27.298 10.726 27.195 4.55301 21.821C-1.62099 16.448 -1.50099 7.837 4.82201 2.589C11.144 -2.658 21.274 -2.556 27.447 2.818C33.621 8.192 33.501 16.802 27.179 22.05H27.178Z"
							fill="url(#paint3_linear_2_2)"
						/>
					</g>
				</g>
				<path
					d="M23.117 6.044C22.5421 5.95562 21.9544 6.00602 21.403 6.191C20.8588 6.37221 20.3676 6.68476 19.973 7.101C19.231 7.891 19 8.92 19.178 9.951C19.34 10.88 19.554 11.823 19.602 12.718C19.6688 14.0696 19.4521 15.4201 18.966 16.683C18.526 17.831 17.898 18.721 16.554 18.918C16.454 18.933 16.091 18.943 15.988 18.948C15.8109 18.9485 15.634 18.9388 15.458 18.919C14.113 18.722 13.48 17.832 13.04 16.677C12.5543 15.414 12.338 14.0635 12.405 12.712C12.453 11.82 12.667 10.876 12.829 9.944C13.007 8.914 12.776 7.884 12.034 7.094C11.6379 6.678 11.1454 6.36612 10.6 6.186C10.0475 6.00238 9.45913 5.95369 8.884 6.044C7.159 6.311 6.01 7.766 6 9.291C5.99593 9.88234 6.16448 10.462 6.485 10.959C7.022 11.799 7.903 12.413 8.672 13.049C9.181 13.475 10.06 14.684 10.492 15.993C10.752 16.786 10.966 17.59 11.177 18.401C11.472 19.532 11.879 22.03 12.147 23.164C12.682 25.434 14.317 25.948 15.957 26H16.016C17.656 25.948 19.318 25.433 19.853 23.163C20.12 22.029 20.525 19.53 20.823 18.401C21.035 17.593 21.247 16.785 21.508 15.992C21.94 14.682 22.819 13.47 23.328 13.048C24.097 12.41 24.977 11.798 25.515 10.958C25.8355 10.461 26.004 9.88134 26 9.29C25.99 7.761 24.847 6.306 23.117 6.044Z"
					fill="white"
				/>
			</g>
			<defs>
				<filter
					id="filter0_f_2_2"
					x="-12.7828"
					y="-4.46265"
					width="50.8786"
					height="48.481"
					filterUnits="userSpaceOnUse"
					color-interpolation-filters="sRGB"
				>
					<feFlood flood-opacity="0" result="BackgroundImageFix" />
					<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
					<feGaussianBlur stdDeviation="5" result="effect1_foregroundBlur_2_2" />
				</filter>
				<filter
					id="filter1_f_2_2"
					x="-10"
					y="-11.2803"
					width="52.0001"
					height="47.2001"
					filterUnits="userSpaceOnUse"
					color-interpolation-filters="sRGB"
				>
					<feFlood flood-opacity="0" result="BackgroundImageFix" />
					<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
					<feGaussianBlur stdDeviation="5" result="effect1_foregroundBlur_2_2" />
				</filter>
				<linearGradient
					id="paint0_linear_2_2"
					x1="2.609"
					y1="4.348"
					x2="26.435"
					y2="28.87"
					gradientUnits="userSpaceOnUse"
				>
					<stop stop-color="#649A66" />
					<stop offset="1" stop-color="#2B4CCF" />
				</linearGradient>
				<linearGradient
					id="paint1_linear_2_2"
					x1="2.609"
					y1="4.348"
					x2="26.435"
					y2="28.87"
					gradientUnits="userSpaceOnUse"
				>
					<stop stop-color="#649A66" />
					<stop offset="1" stop-color="#2B4CCF" />
				</linearGradient>
				<linearGradient
					id="paint2_linear_2_2"
					x1="8.64"
					y1="32.48"
					x2="12.754"
					y2="20.464"
					gradientUnits="userSpaceOnUse"
				>
					<stop stop-color="#8FEBFF" />
					<stop offset="1" stop-color="#2B4CCF" stop-opacity="0" />
				</linearGradient>
				<linearGradient
					id="paint3_linear_2_2"
					x1="14.431"
					y1="1.402"
					x2="14.179"
					y2="26.309"
					gradientUnits="userSpaceOnUse"
				>
					<stop stop-color="#49F150" />
					<stop offset="1" stop-color="#2B4CCF" stop-opacity="0" />
				</linearGradient>
				<clipPath id="clip0_2_2">
					<rect width="32" height="32" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};

export default VenomLogo;
